"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_core_1 = require("roosterjs-editor-core");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var QUOTE_TAG = 'BLOCKQUOTE';
var STRUCTURED_TAGS = [QUOTE_TAG, 'LI', 'TD', 'TH'].join(',');
/**
 * UnquoteWhenBackOnEmpty1stLine edit feature, provides the ability to Unquote current line when
 * user press BACKSPACE on first and empty line of a BLOCKQUOTE
 */
exports.UnquoteWhenBackOnEmpty1stLine = {
    keys: [8 /* BACKSPACE */],
    shouldHandleEvent: function (event, editor) {
        var childOfQuote = cacheGetQuoteChild(event, editor);
        return childOfQuote && roosterjs_editor_dom_1.isNodeEmpty(childOfQuote) && !childOfQuote.previousSibling;
    },
    handleEvent: splitQuote,
};
/**
 * UnquoteWhenEnterOnEmptyLine edit feature, provides the ability to Unquote current line when
 * user press ENTER on an empty line of a BLOCKQUOTE
 */
exports.UnquoteWhenEnterOnEmptyLine = {
    keys: [13 /* ENTER */],
    shouldHandleEvent: function (event, editor) {
        var childOfQuote = cacheGetQuoteChild(event, editor);
        var shift = event.rawEvent.shiftKey;
        return !shift && childOfQuote && roosterjs_editor_dom_1.isNodeEmpty(childOfQuote);
    },
    handleEvent: function (event, editor) { return editor.performAutoComplete(function () { return splitQuote(event, editor); }); },
};
function cacheGetQuoteChild(event, editor) {
    return roosterjs_editor_core_1.cacheGetEventData(event, 'QUOTE_CHILD', function () {
        var quote = editor.getElementAtCursor(STRUCTURED_TAGS);
        if (quote && roosterjs_editor_dom_1.getTagOfNode(quote) == QUOTE_TAG) {
            var pos = editor.getFocusedPosition();
            var block = pos && editor.getBlockElementAtNode(pos.normalize().node);
            if (block) {
                var node = block.getStartNode() == quote
                    ? block.getStartNode()
                    : block.collapseToSingleElement();
                return roosterjs_editor_dom_1.isNodeEmpty(node) ? node : null;
            }
        }
        return null;
    });
}
function splitQuote(event, editor) {
    editor.addUndoSnapshot(function () {
        var childOfQuote = cacheGetQuoteChild(event, editor);
        var parent;
        if (roosterjs_editor_dom_1.getTagOfNode(childOfQuote) == QUOTE_TAG) {
            childOfQuote = roosterjs_editor_dom_1.wrap(roosterjs_editor_dom_1.toArray(childOfQuote.childNodes));
        }
        parent = roosterjs_editor_dom_1.splitBalancedNodeRange(childOfQuote);
        roosterjs_editor_dom_1.unwrap(parent);
        editor.select(childOfQuote, 0 /* Begin */);
    });
    event.rawEvent.preventDefault();
}
//# sourceMappingURL=quoteFeatures.js.map